var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "login-container",
      on: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.login.apply(null, arguments)
        },
      },
    },
    [
      _c("img", {
        class: {
          "login-logo": _vm.VUEAPPWEBSETESIGN === "ps",
          "login-lt-logo": _vm.VUEAPPWEBSETESIGN === "lt",
        },
        attrs: { src: _vm.pcLogo, alt: "logo" },
      }),
      _c(
        "div",
        {
          class: {
            "login-logo-app": _vm.VUEAPPWEBSETESIGN === "ps",
            "login-logo-lt": _vm.VUEAPPWEBSETESIGN === "lt",
          },
        },
        [
          _c("img", {
            staticClass: "logo-app",
            attrs: { src: _vm.h5Logo, alt: "logo" },
          }),
        ]
      ),
      _c(
        "div",
        { staticClass: "form-box" },
        [
          _c("div", { staticClass: "form-title" }, [
            _vm._v(_vm._s(_vm.$t("auth.logIntoYourAccount"))),
          ]),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form-container",
              attrs: { onclick: "return false" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c("div", { staticClass: "va-row" }, [
                _c("div", { staticClass: "flex md12 w-100" }, [
                  _c("div", { staticClass: "label-title" }, [
                    _c("span", { staticClass: "label-title-text" }, [
                      _vm._v(_vm._s(_vm.$t("auth.businessEmail"))),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      class: {
                        "has-error": _vm.errors.has("Business Email"),
                        valid: _vm.isFormFieldValid("Business Email"),
                      },
                    },
                    [
                      _c("el-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email",
                            expression: "'required|email'",
                          },
                        ],
                        staticClass: "login-form-input",
                        class: {
                          "input-error": _vm.errors.first("Business Email"),
                        },
                        attrs: {
                          name: "Business Email",
                          required: "",
                          "data-vv-validate-on": "change",
                          autocomplete: "off",
                        },
                        model: {
                          value: _vm.loginForm.username,
                          callback: function ($$v) {
                            _vm.$set(_vm.loginForm, "username", $$v)
                          },
                          expression: "loginForm.username",
                        },
                      }),
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("Business Email"),
                              expression: "errors.has('Business Email')",
                            },
                          ],
                          staticClass: "help text-danger",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex",
                              staticStyle: { "margin-top": "12px" },
                            },
                            [
                              _vm.errors.first("Business Email")
                                ? _c("img", {
                                    staticStyle: { "margin-right": "6px" },
                                    attrs: {
                                      src: require("@/assets/images/login/attention.svg"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.errors.first("Business Email"))
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "flex md12 w-100" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "label-title d-flex align--end justify--space-between",
                    },
                    [
                      _c("span", { staticClass: "label-title-text" }, [
                        _vm._v(_vm._s(_vm.$t("auth.password"))),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "forgot-password",
                          on: { click: _vm.forgetPassword },
                        },
                        [_vm._v(_vm._s(_vm.$t("auth.forgotYourPassword")))]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "password-container",
                      class: {
                        "has-error": _vm.errors.has("Password"),
                        valid: _vm.isFormFieldValid("Password"),
                      },
                    },
                    [
                      _c("el-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        staticClass: "login-form-password",
                        class: { "input-error": _vm.errors.first("Password") },
                        attrs: {
                          name: "Password",
                          required: "",
                          autocomplete: "off",
                          type: _vm.isOpen ? "text" : "password",
                        },
                        model: {
                          value: _vm.loginForm.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.loginForm, "password", $$v)
                          },
                          expression: "loginForm.password",
                        },
                      }),
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("Password"),
                              expression: "errors.has('Password')",
                            },
                          ],
                          staticClass: "help text-danger",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex",
                              staticStyle: { "margin-top": "12px" },
                            },
                            [
                              _vm.errors.first("Password")
                                ? _c("img", {
                                    staticStyle: { "margin-right": "6px" },
                                    attrs: {
                                      src: require("@/assets/images/login/attention.svg"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _c("span", [
                                _vm._v(_vm._s(_vm.errors.first("Password"))),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "eye-password" }, [
                        !_vm.isOpen
                          ? _c("img", {
                              attrs: { src: _vm.closeEye, alt: "" },
                              on: {
                                click: () => {
                                  _vm.isOpen = true
                                },
                              },
                            })
                          : _vm._e(),
                        _vm.isOpen
                          ? _c("img", {
                              attrs: { src: _vm.openEye, alt: "" },
                              on: {
                                click: () => {
                                  _vm.isOpen = false
                                },
                              },
                            })
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ]),
                _vm.multipleAttempt
                  ? _c("div", { staticClass: "attempt-remaining" }, [
                      _c("div", { staticClass: "remaining-title" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/login/vector.svg"),
                            alt: "",
                          },
                        }),
                        _c("h5", [
                          _vm._v(
                            _vm._s(_vm.$t("auth.didYouForgetYourPassword"))
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "remaining-desc" }, [
                        _vm._v(_vm._s(_vm.$t("auth.clickOn")) + " "),
                        _c(
                          "span",
                          {
                            staticClass: "remaining-desc-forgot",
                            on: { click: _vm.forgetPassword },
                          },
                          [_vm._v(_vm._s(_vm.$t("auth.forgotPassword")))]
                        ),
                        _vm._v(
                          " " + _vm._s(_vm.$t("auth.toAvoidBeingLockedOut"))
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _c("div", { attrs: { id: "g-recaptcha-container" } }),
                _vm.verified && _vm.googleRecaptchaFlag
                  ? _c("p", { staticClass: "g-error" }, [
                      _vm._v(_vm._s(_vm.$t("auth.missingRecaptcha"))),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "flex md12 w-100 form-submit" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: !(
                            _vm.loginForm.username &&
                            _vm.loginForm.password &&
                            _vm.errors.items.length === 0
                          ),
                        },
                        on: { click: _vm.submitForm },
                      },
                      [_vm._v(_vm._s(_vm.$t("auth.logIn")))]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }